<div class="validation-errors">
  <ng-container *ngFor="let validation of validationMessages[controlName]">
    <div class="error-message" *ngIf="formGroup.get(controlName).hasError(validation.type) && (formGroup.get(controlName).dirty || formGroup.get(controlName).touched)">
      {{ validation.message }}
    </div>
  </ng-container>
</div>
